module.exports = __webpack_public_path__ + "static/media/mhc.3b97a825.svg";